import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, MinValidator, RequiredValidator, Validators } from '@angular/forms';
import { FEEDBACK_TYPE_CODE, IFeedback } from '../../interfaces/IFeedback.interface';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackComponent implements OnInit {
  @Input() inProgress: boolean = false;
  @Output() onSendFeedback: EventEmitter<IFeedback> = new EventEmitter<IFeedback>();

  selectedFeedbackCode: FEEDBACK_TYPE_CODE = FEEDBACK_TYPE_CODE.FEEDBACK;

  selectedRating = 0;
  nextRate = 0;

  isInvaledRating = false;

  readonly formGroup: FormGroup = this.fb.group({
    rating: [0, [Validators.required, Validators.min(1), Validators.max(5)]],
    feedback_type: [this.selectedFeedbackCode, Validators.required],
    feedback_text: [''],
  });
  readonly ratingValues = [1, 2, 3, 4, 5];
  readonly feedbackTypeOptions = [
    {
      title: 'Пожелания и идеи',
      code: FEEDBACK_TYPE_CODE.FEEDBACK,
    },
    {
      title: 'Ошибки в работе',
      code: FEEDBACK_TYPE_CODE.ERROR,
    },
  ];

  get placeholderText() {
    return this.selectedFeedbackCode === FEEDBACK_TYPE_CODE.FEEDBACK
      ? 'Поделитесь впечатлениями о платформе'
      : 'Напишите, если заметили ошибки в работе';
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit() {}

  onChangeRating(value: number) {
    this.formGroup.patchValue({ rating: value }, { emitEvent: false, onlySelf: true });
    this.selectedRating = value;
    this.validateRating();
  }

  onFeedbackTypeCheck(value: number | string | boolean | null) {
    this.formGroup.patchValue({ feedback_type: value }, { emitEvent: false, onlySelf: true });
    this.selectedFeedbackCode = value as number;
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    if (this.formGroup.invalid) {
      this.validateRating();
      return;
    }

    const { feedback_text, feedback_type, rating } = this.formGroup.value;
    this.onSendFeedback.emit({
      feedback_text,
      feedback_type,
      rating,
    });
  }

  onLeaveRating() {
    this.nextRate = 0;
  }

  onEnterRating(value: number) {
    this.nextRate = value;
  }

  private validateRating() {
    this.isInvaledRating = this.formGroup.get('rating')?.invalid || false;
  }
}
